export class ProductReview {

  city: string;
  state: string;
  comment: string;
  stars: number;
  reviewDate: string;
  reviewName: string;
  score: number;

  constructor(public data: any) {
    if (data) {
      const json: JSON = data;

      this.city = json['city'];
      this.state = json['state'];
      this.comment = json['comment'];
      this.score = json['score'];
      this.stars = json['numStars'];
      this.reviewDate = json['reviewDate'];
      this.reviewName = json['reviewName'];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/model/product-review.ts